jQuery(document).ready(function ($) {
  // Collapse all answers
  $(".oxitab-faqs__answer").hide();
  $(".oxitab-faqs__icon").text("−");

  // Open the first answer and set icon to +
  var firstQuestion = $(".oxitab-faqs__question").first();
  firstQuestion.next(".oxitab-faqs__answer").show();
  firstQuestion.find(".oxitab-faqs__icon").text("+");

  // On click toggle
  $(".oxitab-faqs__question").click(function () {
    var answer = $(this).next(".oxitab-faqs__answer");
    var icon = $(this).find(".oxitab-faqs__icon");

    // If already open, just close it
    if (answer.is(":visible")) {
      answer.slideUp();
      icon.text("−");
    } else {
      // Close all and reset icons
      $(".oxitab-faqs__answer").slideUp();
      $(".oxitab-faqs__icon").text("−");

      // Open selected
      answer.slideDown();
      icon.text("+");
    }
  });
    var $video = $(".oxitab-hero video");

  if ($video.length) {
    $video.each(function () {
      this.controls = false;
    });
  }

});



$(window).on('resize', function() {
    $('.oxi-testimonial-slider').slick('setPosition');
});

  jQuery(document).ready(function($) {
    $(".oxi-question").first().find(".oxi-answer").show();
     $(".oxi-question").click(function() {
      // Toggle active class for the clicked question
      $(this).toggleClass("active");
      
      // Get the answer element
      var $answer = $(this).find(".oxi-answer");
      
      // Toggle the answer visibility
      if ($answer.is(":visible")) {
        $answer.slideUp();
        $answer.removeClass("active");
      } else {
        // Close all other answers
        $(".oxi-question").not($(this)).removeClass("active");
        $(".oxi-answer").not($answer).slideUp().removeClass("active");
        
        // Open this answer
        $answer.slideDown();
        $answer.addClass("active");
      }
    });
  });

jQuery(document).ready(function($){
  
   var $menu = $('.oxitab-nav');
    if ($menu.length) {
        $('.menu-button').on('click', function() {
            toggleMenu(); // make sure toggleMenu is defined
        });
    }
    $('.oxi-testimonial-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        arrows: true,
        prevArrow: '<button class="oxi-slick-prev">&#10094;</button>',
        nextArrow: '<button class="oxi-slick-next">&#10095;</button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
});

document.addEventListener('DOMContentLoaded', function() {
    // Make sure jQuery is available (Shopify includes jQuery by default)
    if (typeof jQuery === 'function') {
      // Generate the table of contents
      generateTableOfContents();
      
      // Add smooth scrolling to all TOC links
      setupSmoothScrolling();
    }
  });

  function generateTableOfContents() {
    // Find all headings in the article content
    var headings = $('#article-content').find('h2');
    var tocList = $('#table-of-contents');
    
    // Clear any existing items
    tocList.empty();
    
    // Exit if no headings found
    if (headings.length === 0) {
      tocList.append('<li>No sections found</li>');
      return;
    }
    
    // Add ID to each heading if it doesn't have one already
    headings.each(function(index) {
      var $heading = $(this);
      if (!$heading.attr('id')) {
        // Create ID from heading text, make it URL-friendly
        var id = 'section-' + index + '-' + $heading.text().toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '');
        
        $heading.attr('id', id);
      }
      
      // Create TOC entry
      var level = parseInt($heading.prop('tagName').substring(1)); // Get the heading level (1-6)
      var indent = (level - 1) * 10; // Calculate indent based on heading level
      
      var listItem = $('<li>')
        .css('padding-left', indent + 'px')
        .append(
          $('<a>')
            .attr('href', '#' + $heading.attr('id'))
            .text($heading.text())
            .addClass('toc-link')
        );
      
      tocList.append(listItem);
    });
  }
  
  function setupSmoothScrolling() {
    // Add smooth scrolling to all TOC links
    $('.toc-link').on('click', function(e) {
      e.preventDefault();
      
      var targetId = $(this).attr('href');
      var $target = $(targetId);
      
      if ($target.length) {
        // Calculate offset (accounting for any fixed headers if present)
        var offset = $target.offset().top - 20; // 20px padding from top
        
        // Animate scroll to the target
        $('html, body').animate({
          scrollTop: offset
        }, 800);
        
        // Update URL without page reload
        if (history.pushState) {
          history.pushState(null, null, targetId);
        }
      }
    });
  }

document.addEventListener("DOMContentLoaded", function () {
  const quantityInput = document.querySelector(".oxi-quantity-input");
  const buttons = document.querySelectorAll(".oxi-quantity-button");

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      let currentValue = parseInt(quantityInput.value);
      if (this.dataset.action === "increase") {
        quantityInput.value = currentValue + 1;
      } else if (this.dataset.action === "decrease" && currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
  });
});
